const Data = [
    {
        id:'1',
        head:'Digestive Glands in Human Body',
        anchor:'/science/activity/DigestiveGlands/'
    },
    {
        id:'2',
        head:'Action of Lemon on Corroded Copper',
        anchor:'/science/activity/CRD_COPPER'
    },
    {
        id:'3',
        head:'Earth Day 2022',
        anchor:'/science/earthday'
    },
    {
        id:'4',
        head:'Soot in Saturated and Unsaturated Carbon Compounds',
        anchor:'/science/activity/SootCarbon'
    },
    {
        id:'5',
        head:"PH of Soil",
        anchor:'/science/activity/Soil-PH'
    },
    {
        id:'6',
        head:"Difference in Earlobes",
        anchor:'/science/activity/Earlobes'
    },
    {
        id:'7',
        head:"Reistors in a Series.",
        anchor:'/science/activity/Circuts-Series'
    },
    {
        id:'8',
        head:'Resistors in Parallel',
        anchor:'/science/activity/Circuts-Parallel'
    },
    {
        id:'9',
        head:'Dispersion of Sunlight',
        anchor:'/science/activity/Dispersion'
    },
    {
        id : '12',
        head : '⬅ Go back',
        anchor : '/'
    }
]

export { Data }